export const languageLevels = [
  { label: "Básico", value: "BASIC" },
  { label: "Intermedio", value: "INTERMEDIATE" },
  { label: "Experto", value: "EXPERT" }
];
